import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Menu, X } from 'lucide-react';
import "../../css/home/header.css";

function Header() {
    const navigate = useNavigate();
    const location = useLocation();
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);

    const getActiveClass = (path) => {
        return location.pathname === path ? "active" : "";
    };

    const toggleDrawer = () => {
        setIsDrawerOpen(!isDrawerOpen);
        // Drawer açıkken scroll'u engelle
        document.body.style.overflow = isDrawerOpen ? 'unset' : 'hidden';
    };

    return (
        <>
            <div className="header">
                <img
                    className="HeaderIcon"
                    onClick={() => navigate("/")}
                    src="/assets/home/firm/DapSarj-Colorcolor-01.png"
                    height="50"
                    alt="Logo"
                />
                <button className="menu-button" onClick={toggleDrawer}>
                    <Menu size={24} color="#005aab" />
                </button>
                <div className="header-right desktop-menu">
                    <button className={`link-button ${getActiveClass("/products")}`} onClick={() => navigate("/products")}>Ürünler</button>
                    <button className={`link-button ${getActiveClass("/calculate")}`} onClick={() => navigate("/calculate")}>Hesapla</button>
                    <button className={`link-button ${getActiveClass("/solitions")}`} onClick={() => navigate("/solitions")}>Çözümler</button>
                    <button className={`link-button ${getActiveClass("/powermanagement")}`} onClick={() => navigate("/powermanagement")}>Güç Yönetimi</button>
                    <button className={`link-button ${getActiveClass("/contact")}`} onClick={() => navigate("/contact")}>İletişim</button>
                    <button className={`link-button ${getActiveClass("/questions")}`} onClick={() => navigate("/questions")}>Sıkça Sorulan Sorular</button>
                </div>
            </div>

            {/* Overlay */}
            {isDrawerOpen && (
                <div className="drawer-overlay" onClick={toggleDrawer}></div>
            )}

            {/* Mobil Drawer Menü */}
            <div className={`mobile-drawer ${isDrawerOpen ? 'open' : ''}`}>
                <div className="drawer-header">
                    <img
                        className="drawer-logo"
                        onClick={() => navigate("/")}
                        src="/assets/home/firm/DapSarj-Colorcolor-01.png"
                        alt="Logo"
                    />
                    <button className="close-button" onClick={toggleDrawer}>
                        <X size={24} color="#005aab" />
                    </button>
                </div>
                <div className="drawer-content">
                    <button className={`link-button ${getActiveClass("/products")}`} onClick={() => { navigate("/products"); toggleDrawer(); }}>Ürünler</button>
                    <button className={`link-button ${getActiveClass("/calculate")}`} onClick={() => { navigate("/calculate"); toggleDrawer(); }}>Hesapla</button>
                    <button className={`link-button ${getActiveClass("/solitions")}`} onClick={() => { navigate("/solitions"); toggleDrawer(); }}>Çözümler</button>
                    <button className={`link-button ${getActiveClass("/powermanagement")}`} onClick={() => { navigate("/powermanagement"); toggleDrawer(); }}>Güç Yönetimi</button>
                    <button className={`link-button ${getActiveClass("/questions")}`} onClick={() => { navigate("/questions"); toggleDrawer(); }}>Sıkça Sorulan Sorular</button>
                    <button className={`link-button ${getActiveClass("/contact")}`} onClick={() => { navigate("/contact"); toggleDrawer(); }}>İletişim</button>
                </div>
            </div>
        </>
    );
}

export default Header;